import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NavMainMenuPage } from './nav-main-menu';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    NavMainMenuPage,
  ],
  imports: [
    IonicPageModule.forChild(NavMainMenuPage),
    DirectivesModule
  ],
})
export class NavMainMenuPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-menus/nav-main-menu/nav-main-menu.module.ts